import simg from '../images/services/icon1.png'
import simg2 from '../images/services/icon2.png'
import simg3 from '../images/services/icon3.png'
import simg4 from '../images/services/icon4.png'
import simg5 from '../images/services/icon5.png'
import simg6 from '../images/services/icon6.png'

import sSimg1 from '../images/service-single/img-1.jpg'
import sSimg2 from '../images/service-single/img-2.jpg'
import sSimg3 from '../images/service-single/img-3.jpg'
import sSimg4 from '../images/service-single/img-1.jpg'
import sSimg5 from '../images/service-single/img-2.jpg'
import sSimg6 from '../images/service-single/img-3.jpg'

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'

const Services = [
    {
        Id: '1',
        sImg:simg,
        sSimg:sSimg1,
        sTitle: 'Search Homes & Properties',
        slug: 'Search Homes & Properties',
        description:'Search your dream home, find your perfect property',
        des2:'Elementum aliquam byuerirra sagittis duis non quis.',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '2',
        sImg:simg2,
        sSimg:sSimg2,
        sTitle: 'Personalized Property Solutions',
        slug: 'Personalized Property Solutions',
        description:'Your dream home, your way. Personalized properties to match your lifestyle',
        des2:'Elementum aliquam byuerirra sagittis duis non quis.',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '3',
        sImg:simg3,
        sSimg:sSimg3,
        sTitle: 'Lifestyle & Amenities',
        slug: 'Lifestyle & Amenities',
        description:'Experience the epitome of luxury living.Discover world-class amenities and a refined lifestyle.',
        des2:'Elementum aliquam byuerirra sagittis duis non quis.',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '4',
        sImg:simg4,
        sSimg:sSimg4,
        sTitle: 'INVESTMENT ADVISORY',
        slug: 'INVESTMENT ADVISORY',
        description:'Maximize your returns with expert real estate investment guidance. From identifying high-growth locations to analyzing market trends, we help you make smart, profitable property decisions.',
        des2:'Elementum aliquam byuerirra sagittis duis non quis.',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '5',
        sImg:simg5,
        sSimg:sSimg5,
        sTitle: 'PROPERTY MANAGEMENT',
        slug: 'PROPERTY MANAGEMENT',
        description:'Seamless property management services to protect your investment. From tenant support to rent collection and maintenance, we handle everything so you can enjoy peace of mind.',
        des2:'Elementum aliquam byuerirra sagittis duis non quis.',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
    {
        Id: '6',
        sImg:simg6,
        sSimg:sSimg6,
        sTitle: 'Concept Planning',
        slug: 'Concept-Planning',
        description:'Laying the Groundwork for Success.Comprehensive Planning for Your Project',
        des2:'Elementum aliquam byuerirra sagittis duis non quis.',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
    },
]
export default Services;